module.exports = "<div class=\"dev-info\">\n  <app-frontend-version></app-frontend-version>\n  <app-backend-version></app-backend-version>\n</div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main